import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    careerpages: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_CAREERPAGE_SELECT_IDS (store, ids) {
      store.careerpages.selectIds = ids
    },
    REMOVE_CAREERPAGE_SELECT_IDS (store, ids) {
      store.careerpages.selectIds = store.careerpages.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CAREERPAGE_SELECT_ID (store, id) {
      store.careerpages.selectId = id
    },
    SET_CAREERPAGE_FILTERS (store, filters) {
      store.careerpages.filters = filters
    },
    SET_CAREERPAGE_PAGINATE (store, val) {
      store.careerpages.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getCareerpages: (store, getters) => {
      return store.careerpages.selectIds.map((id) => {
        return getters['entities/careerpages/find'](id)
      })
    },
    getCareerpagesFilters: (store, getters) => {
      return store.careerpages.filters
    },
    getCareerpagesPaginate: (store, getters) => {
      return store.careerpages.paginate
    },
    getCareerpage: (store, getters) => {
      return getters['entities/careerpages/find'](store.careerpages.selectId) || {}
    }
  },
  actions: {
    /*
    selectCareerpages
    */
    selectCareerpages ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCareerpages', filters)
      .then((response) => {
        commit('SET_CAREERPAGE_FILTERS', filters)
        commit('SET_CAREERPAGE_PAGINATE', response)
        commit('SET_CAREERPAGE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCareerpages
    */
    refreshSelectCareerpages ({commit, dispatch, getters, state}) {
      return dispatch('selectCareerpages', getters.getCareerpagesFilters)
    },
    /*
    selectCareerpage
    */
    selectCareerpage ({commit, dispatch, getters, state}, id) {
      return dispatch('getCareerpageById', id)
      .then((response) => {
        commit('SET_CAREERPAGE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCareerpages
    */
    getCareerpages ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/careerpages`, {params: filters})
      .then((response) => {
        return dispatch('entities/careerpages/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.careerpages || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getCareerpageById
    */
    getCareerpageById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/careerpages/${id}`)
      .then((response) => {
        return dispatch('entities/careerpages/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.careerpages[0]
      })
    },
    /*
    createCareerpage
    */
    createCareerpage ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/careerpages`, data)
      .then((response) => {
        return dispatch('entities/careerpages/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.careerpages[0]
      })
    },
    /*
    updateCareerpage
    */
    updateCareerpage ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/careerpages/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/careerpages/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.careerpages[0]
      })
    },
    /*
    deleteCareerpage
    */
    deleteCareerpage ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/careerpages/${id}`)
      .then((response) => {
        commit('REMOVE_CAREERPAGE_SELECT_IDS', [id])
        dispatch('entities/careerpages/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Careerpage.js